import './style.scss'
import { useContext, useEffect, useState } from "react"
import { useNavigate, useParams } from 'react-router-dom'
import { IoIosArrowBack, IoIosStarOutline } from "react-icons/io"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import ApiContext from 'src/provider/API/call-service'
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import { AppSpan, AppText, Button, Circle, CustomContainer, FlexRow, GridContainer, PageTitle, PageWrapper } from "src/style"
import utility from "src/utils/utility"
import { Dropdown } from 'src/component'
import { BsThreeDotsVertical } from 'react-icons/bs'
import QoreidIcon from 'src/assets/img/qoreid-icon.png'
import BankinglyIcon from 'src/assets/img/bankingly-icon.png'
import { RiCloseFill } from 'react-icons/ri'
import { MdOutlineCheck } from "react-icons/md";
import { IoIosStar } from "react-icons/io";
import { CreateProduct, EditProduct, EditServiceProvider } from 'src/popup'
import { Product } from 'src/model'

const ServiceProviderDetails = () => {
    const navigate = useNavigate()
    const { providerId } = useParams()
    const {API} = useContext(ApiContext)
    const {info: {selectedServiceProvider}, setInfoProperty} = useContext(AppInfoContext)
    const {decisionBox} = useContext(VisibilityContext)
    const [provider, setProvider] = useState(selectedServiceProvider)
    const [products, setProducts] = useState<Array<Product>|null>(null)
    const [selectedProduct, setSelectedProduct] = useState<Product|null>(null)
    const [view, setView] = useState('')

    useEffect(() => {
        if (selectedServiceProvider.id) {
            setProvider(selectedServiceProvider)
            handleFetchProducts()
        }
    }, [selectedServiceProvider])

    useEffect(() => {
        API.getServiceProviderById(providerId)
    }, [])

    async function handleFetchProducts() {
        const response = await API.getProductsWithoutPagination({serviceProviderId: selectedServiceProvider.id})
        
        if (response) {
            setProducts(response)
        }
    }

    async function handleProductAction (product: Product, value: string) {
        if (value === 'view') {
            await setInfoProperty('selectedProduct', product)
            navigate(`/admin/administration/product/${product.id}`)
        }
        else if (value === 'edit') {
            await setSelectedProduct(product)
            setView('edit-product')
        }
        else {
            decisionBox.show(
                `Are you sure you want to ${value} this product?`,
                () => handleOtherProductAction(product, value),
                decisionBox.hide,
                `Yes, ${utility.toTitleCase(value)}`,
                'No'
            )
        }
    }

    async function handleOtherProductAction (product: Product, type: string) {
        let response;

        if (type === 'delete') response = await API.deleteProduct(product.id)
        else if (type === 'activate') response = await API.activateProduct(product.id)
        else if (type === 'deactivate') response = await API.deactivateProduct(product.id)
        else if (type === 'publish') response = await API.publishProduct(product.id, true)
        else if (type === 'unpublish') response = await API.publishProduct(product.id, false)

        if (response) handleFetchProducts()
    }

    return (
        <>
            <PageWrapper>
                <FlexRow justifyContent="space-between" gap="2.5" wrap='wrap'>
                    <FlexRow 
                        width="auto" sizeUnit="" gap="1"
                        onClick={() => navigate(-1)}
                    >
                        <AppSpan textSize='2.5' cursor='pointer' bottomMargin='1' >
                            <IoIosArrowBack />
                        </AppSpan>
                        {/* <CustomContainer 
                            width="3" height="3.6"
                            style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} 
                        >
                            <img src={provider?.logo} className='img-covered' style={{objectFit: 'contain'}} />
                        </CustomContainer> */}
                        <Circle 
                            size="5" bgColor='#ffffff' 
                            borderColor='#EAECF0'
                            className='fixed-flex-shape'
                            style={{overflow: 'hidden'}}
                        >
                            <Circle 
                                size='4'
                                style={{overflow: 'hidden'}}
                            >
                                <img 
                                    src={provider?.logoUrl} 
                                    className='img-covered' 
                                    style={{objectFit: 'contain'}} 
                                />
                            </Circle>
                        </Circle>
                        <PageTitle 
                            color='#101828' textSize='3' fontWeight="500"
                        >
                            Service provider details
                        </PageTitle>
                    </FlexRow>
                    <Button
                        width='10.8'
                        titleSize='1.4' fontWeight="500"
                        height='4' radius='0.8'
                        hoverColor='#0D968F'
                        hoverBgColor='#fff' borderColor='#0D968F'
                        onClick={() => setView('edit-provider')}
                    >
                        Edit details
                    </Button>
                </FlexRow>
                <CustomContainer topMargin='2'>
                    <FlexRow
                        minHeight='11.7' padding='2.5' wrap='wrap'
                        borderColor='#EAECF0' radius='0.8' gap='2.5'
                        bgColor='#ffffff' justifyContent='space-between'
                        alignItems='flex-start'
                    >
                        <CustomContainer width='auto' sizeUnit=''>
                            <AppText 
                                color='#333542' fontWeight="600" textSize='1.6'
                            >
                                Service provider
                            </AppText>
                            <AppSpan 
                                color='#333542' fontWeight='300'
                            >
                                {provider.companyName}
                            </AppSpan>
                        </CustomContainer>
                        <CustomContainer width='auto' sizeUnit=''>
                            <AppText 
                                color='#333542' fontWeight="600" textSize='1.6'
                            >
                                Service provider ID
                            </AppText>
                            <AppSpan 
                                color='#333542' fontWeight='300'
                            >
                                {provider.id}
                            </AppSpan>
                        </CustomContainer>
                        <CustomContainer width='auto' sizeUnit=''>
                            <AppText 
                                color='#333542' fontWeight="600" textSize='1.6'
                            >
                                Service provider website
                            </AppText>
                            <AppSpan 
                                color='#333542' fontWeight='300'
                            >
                                {provider.websiteURL}
                            </AppSpan>
                        </CustomContainer>
                        <CustomContainer width='auto' sizeUnit=''>
                            <AppText 
                                color='#333542' fontWeight="600" textSize='1.6'
                            >
                                Fee settlement account
                            </AppText>
                            <AppSpan 
                                color='#333542' fontWeight='300'
                            >
                                {provider.feeSettlementAccount}
                            </AppSpan>
                        </CustomContainer>
                    </FlexRow>
                    <CustomContainer topMargin='1.5'>
                        <AppSpan 
                            color='#101828' textSize='2' fontWeight="500"
                        >
                            Admin details
                        </AppSpan>
                        <FlexRow
                            minHeight='11.7' padding='2.5' wrap='wrap'
                            borderColor='#EAECF0' radius='0.8' gap='2.5'
                            bgColor='#ffffff' justifyContent='space-between'
                            topMargin='1'
                        >
                            <CustomContainer width='auto' sizeUnit=''>
                                <AppText 
                                    color='#333542' fontWeight="600" textSize='1.6'
                                >
                                    First name
                                </AppText>
                                <AppSpan 
                                    color='#333542' fontWeight='300'
                                >
                                    {provider?.admin?.firstName}
                                </AppSpan>
                            </CustomContainer>
                            <CustomContainer width='auto' sizeUnit=''>
                                <AppText 
                                    color='#333542' fontWeight="600" textSize='1.6'
                                >
                                    Surname
                                </AppText>
                                <AppSpan 
                                    color='#333542' fontWeight='300'
                                >
                                    {provider?.admin?.lastName}
                                </AppSpan>
                            </CustomContainer>
                            <CustomContainer width='auto' sizeUnit=''>
                                <AppText 
                                    color='#333542' fontWeight="600" textSize='1.6'
                                >
                                    Email
                                </AppText>
                                <AppSpan 
                                    color='#333542' fontWeight='300'
                                >
                                    {provider?.admin?.email}
                                </AppSpan>
                            </CustomContainer>
                            <CustomContainer width='auto' sizeUnit=''>
                                <AppText 
                                    color='#333542' fontWeight="600" textSize='1.6'
                                >
                                    Phone number
                                </AppText>
                                <AppSpan 
                                    color='#333542' fontWeight='300'
                                >
                                    {provider?.admin?.phoneNumber}
                                </AppSpan>
                            </CustomContainer>
                        </FlexRow>
                    </CustomContainer>
                </CustomContainer>
                <CustomContainer topMargin='2'>
                    <FlexRow 
                        justifyContent='space-between' gap='2.5'
                    >
                        <AppSpan color='#101828' textSize='2' fontWeight="500">Products</AppSpan>
                        <Button
                            width='16.8'
                            height='4' radius='0.8'
                            hoverColor='#0D968F'
                            hoverBgColor='#fff' 
                            borderColor='#0D968F'
                            onClick={() => setView('create-product')}
                        >
                            Create new product
                        </Button>
                    </FlexRow>
                    <FlexRow 
                        gap='2' alignItems='flex-start'
                        topMargin='1.5' wrap='wrap'
                    >
                        {
                            products?.map((product, index) => {
                                return (
                                    <CustomContainer
                                        width='38.9' minHeight='26.9'
                                        radius='0.8' borderColor='#EAECF0'
                                        padding='2' key={index}
                                        className='service-provider-products'
                                    >
                                        <FlexRow 
                                            justifyContent='space-between'
                                        >
                                            <FlexRow width='auto' sizeUnit='' gap='1.5'>
                                                {/* <CustomContainer 
                                                    width="3.8" height="4.8"
                                                    style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} 
                                                >
                                                    <img src={product.logoUrl} className='img-covered'/>
                                                </CustomContainer> */}
                                                <Circle 
                                                    size="5" bgColor='#ffffff' 
                                                    borderColor='#EAECF0'
                                                    className='fixed-flex-shape'
                                                    style={{overflow: 'hidden'}}
                                                >
                                                    <Circle 
                                                        size='4'
                                                        style={{overflow: 'hidden'}}
                                                    >
                                                        <img 
                                                            src={product.logoUrl} 
                                                            className='img-covered' 
                                                            style={{objectFit: 'contain'}} 
                                                        />
                                                    </Circle>
                                                </Circle>
                                                <AppSpan 
                                                    color='#101828' fontWeight="500" textSize='1.6'
                                                >
                                                    {product.name}
                                                </AppSpan>
                                            </FlexRow>
                                            <Dropdown 
                                                trigger={<BsThreeDotsVertical fontSize='1.6rem' color='#3A3A3A' />}
                                                options={[
                                                    {value: 'view', label: 'View product'},
                                                    // {value: 'edit', label: 'Edit product'},
                                                    !product.isPublished ? {value: 'publish', label: 'Publish product'} : {value: 'unpublish', label: 'Unpublish product'},
                                                    {
                                                        value: product.status === 'Active' ? 'deactivate' : 'activate', 
                                                        label: `${product.status === 'Active' ? 'Deactivate' : 'Activate'} product`
                                                    },
                                                    {value: 'delete', label: 'Delete product'}
                                                ].filter(Boolean)}
                                                onSelect={(value: string) => handleProductAction(product, value)}
                                            />
                                        </FlexRow>
                                        <FlexRow 
                                            justifyContent='space-between' gap='2'
                                            topMargin='1.5'
                                        >
                                            <AppSpan textSize='2.5' fontWeight="600" color='#409089'>
                                                {product.setupFee ? `₦${product.setupFee}` : 'Free'}
                                            </AppSpan>
                                            <GridContainer 
                                                width='auto' sizeUnit='' minHeight='2.2'
                                                leftPadding='1' rightPadding='1' radius='1.6'
                                                bgColor={product.status === 'Active' ? '#E7F6F5' : '#F2F4F7'}
                                            >
                                                <AppSpan
                                                    color={product.status === 'Active' ? '#0A756F' : '#344054'}
                                                    textSize='1.2' fontWeight="500"
                                                >
                                                    {product.status}
                                                </AppSpan>
                                            </GridContainer>
                                        </FlexRow>
                                        <GridContainer 
                                            width={product.isPublished ? '10' : '13'} 
                                            minHeight='2.2'
                                            leftPadding='1' rightPadding='1' radius='1.6'
                                            bgColor={product.isPublished ? '#E7F6F5' : '#F2F4F7'}
                                            topMargin='0.8'
                                        >
                                            <FlexRow width='auto' sizeUnit='' gap='0.5'>
                                                <AppSpan
                                                    color={product.isPublished ? '#027A48' : '#344054'}
                                                    textSize='1.2' fontWeight="500"
                                                >
                                                    {product.isPublished ? 'Published' : 'Not-published'}
                                                </AppSpan>
                                                { product.isPublished ?
                                                    <MdOutlineCheck fill='#12B76A' fontSize='1.2rem' />
                                                    : <RiCloseFill fill='#667085' fontSize='1.2rem' />
                                                }
                                            </FlexRow>
                                        </GridContainer>
                                        <AppText topMargin='1'>{product.description}</AppText>
                                        <FlexRow 
                                            justifyContent='space-between' gap='2.5'
                                            topMargin='1'
                                        >
                                            <FlexRow width='auto' sizeUnit='' gap='0.5'>
                                                {
                                                    Array.from(Array(5).keys()).map((item) => {
                                                        return (
                                                            <CustomContainer 
                                                                width='auto' sizeUnit=''
                                                                key={item}
                                                            >
                                                                { product.productStatistic?.averageRating >= (item + 1) ?
                                                                    <IoIosStar fill='#409089' fontSize='1.6rem' />
                                                                    : <IoIosStarOutline fill='#344054' fontSize='1.6rem' />
                                                                }
                                                            </CustomContainer>
                                                        )
                                                    })
                                                }
                                            </FlexRow>
                                            <AppSpan textSize='1.25'>{product.productStatistic?.averageRating.toFixed(1)}</AppSpan>
                                        </FlexRow>
                                    </CustomContainer>
                                )
                            })
                        }
                    </FlexRow>
                </CustomContainer>
            </PageWrapper>
            { view === 'edit-provider' &&
                <EditServiceProvider 
                    data={provider}
                    close={() => setView('')}
                />
            }
            { view === 'create-product' &&
                <CreateProduct 
                    serviceProviderId={provider.id}
                    fetchProducts={handleFetchProducts}
                    close={() => setView('')}
                />
            }
            { view === 'edit-product' &&
                <EditProduct
                    data={selectedProduct}
                    fetchProducts={handleFetchProducts} 
                    close={() => setView('')}
                />
            }
        </>
    )
}

export default utility.routeData('administration/service-provider/:providerId', 'Service Provider Details', <ServiceProviderDetails/>)


// const products = [
//     {
//         id: 123,
//         name: 'Bankingly',
//         icon: BankinglyIcon,
//         amount: '500',
//         isPublished: false,
//         description: 'Bankingly is a platform that provides business deposit accounts to companies...',
//         rating: 4,
//         status: 'Active'
//     },
//     {
//         id: 124,
//         name: 'Bankingly',
//         icon: BankinglyIcon,
//         amount: '500',
//         isPublished: false,
//         description: 'Bankingly is a platform that provides business deposit accounts to companies...',
//         rating: 4,
//         status: 'Active'
//     },
//     {
//         id: 125,
//         name: 'Qoreid',
//         icon: QoreidIcon,
//         isPublished: true,
//         description: 'Novo is a banking platform that provides business deposit accounts to companies...',
//         rating: 4,
//         status: 'Inactive'
//     }
// ]